/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';
import { assertNoUndefinedProperties } from 'tradera/utils/assert';
import { getItemState } from '../view-item/item-state-helper';
import { getAmountDetails } from 'tradera/apps/tradera/components/vip/bidding/bid-details'; // TODO put getAmountDetails somewhere else
import { VIEW_STATES } from './constants';

export const initialState = {
    amount: 0,
    breadCrumbs: [],
    categoryId: 0,
    categoryNames: [],
    categories: [],
    categoryLevel: 0,
    description: null,
    hasEnded: false,
    images: [],
    itemId: 0,
    itemUrl: null,
    paymentOptions: [],
    paymentTerms: null,
    reasons: [],
    resultMessage: null,
    shippingOptions: [],
    shippingTerms: [],
    sellerMemberId: 0,
    title: null,
    viewState: VIEW_STATES.LOADING,
    itemDetails: null
};

const slice = createSlice({
    name: 'reportItem',
    initialState,
    reducers: {
        resetInitialState: () => {
            return initialState;
        },
        setReportItem: (state, { payload: { item, itemUrl, reasons } }) => {
            const itemDetails = item.itemDetails;
            const bidInfo = item.bidInfo;
            const itemState = getItemState(
                itemDetails.hasEnded,
                itemDetails.hasStarted,
                itemDetails.itemType,
                bidInfo.bidCount,
                bidInfo.reservePriceReached,
                bidInfo.nextValidBidAmount,
                bidInfo.transactionType,
                bidInfo.leadingBidderMemberId
            );
            const amountDetails = getAmountDetails(
                itemState,
                itemDetails.fixedPrice,
                bidInfo.leadingBidAmount,
                itemDetails.openingBid,
                bidInfo.bidCount > 0
            );
            state.amount = amountDetails.amount;
            state.allowedBuyerRegion = itemDetails.allowedBuyerRegion;
            state.breadCrumbs = item.breadCrumbs;
            state.categoryId = itemDetails.categoryId;
            state.categoryNames = item.breadCrumbs.map(
                (breadCrumb) => breadCrumb.text
            );
            state.description = itemDetails.description;
            state.endDate = itemDetails.endDate;
            state.hasEnded = itemDetails.hasEnded;
            state.images = itemDetails.images;
            state.itemId = itemDetails.itemId;
            state.itemUrl = itemUrl;
            state.paymentOptions = itemDetails.paymentOptions;
            state.reasons = reasons;
            state.shippingOptions = itemDetails.shippingOptions;
            state.shippingTerms = itemDetails.shippingTerms;
            state.sellerMemberId = itemDetails.sellerMemberId;
            state.title = itemDetails.title;
            state.viewState = itemDetails.hasEnded
                ? VIEW_STATES.ITEM_ENDED
                : VIEW_STATES.FORM;
            state.itemDetails = itemDetails;
            assertNoUndefinedProperties(state);
        },
        setViewState: (state, { payload }) => {
            state.viewState = payload;
        },
        setCategories: (state, { payload: categories, categoryLevel }) => {
            state.categories = categories;
            state.categoryLevel = categoryLevel;
        }
    }
});

export const { resetInitialState, setReportItem, setViewState, setCategories } =
    slice.actions;
export const reducer = slice.reducer;
